import React from 'react';
import { theme } from 'antd';
import ScrollEdgeFrame from '../../../components/shared/ScrollEdgeFrame';
import './supplier-enquiries.css';

export function EnquirySection({ title, children, extra, subtitle }) {
  const { token } = theme.useToken();
  return <section className="enquiry-section" style={{ border: `1px solid ${token.colorBorderSecondary}`, color: token.colorText }}>
    <header style={{ background: token.colorBgElevated }}><div className="enquiry-section-heading"><div>{title}</div>{extra}</div>
      {subtitle && <div style={{ color: token.colorTextSecondary, fontSize: 12, fontWeight: 400, marginTop: 4 }}>{subtitle}</div>}
    </header><div className="enquiry-section-body">{children}</div>
  </section>;
}

export function EnquiryScroll({ children, className = '', label }) {
  return <ScrollEdgeFrame className={`enquiry-scroll-frame ${className}`}><div role={label ? 'region' : undefined} aria-label={label} data-scroll-edge-viewport className="enquiry-scroll-content">{children}</div></ScrollEdgeFrame>;
}

export function EnquirySidePane({ children, label }) {
  const { token } = theme.useToken();
  return <aside className="enquiry-side-pane" aria-label={label} style={{ background: token.colorBgElevated, borderLeft: `1px solid ${token.colorBorderSecondary}` }}>{children}</aside>;
}
